define((require) => {
    "use strict";

    const IntegrationModel = require("editor/ui/settings/integrations/IntegrationModel");

    /**
     * Amazon Rekognition integration model.
     *
     * @class AmazonRekognitionIntegrationModel
     */
    return IntegrationModel.extend("AmazonRekognitionIntegration", {

        defaults: {
            minConfidence: null
        }

    }, {
        type: "AmazonRekognitionIntegration"
    });
});



// WEBPACK FOOTER //
// ./src/editor/ui/settings/integrations/AmazonRekognitionIntegrationModel.js